module.exports = __webpack_public_path__ + "img/bg-demographics.5d72b710.jpg";